export const VideoInteracted = {
  "videoId": "",
  "videoName": "",
  "videoState": "",
  "videoMileStone": "",
  "pageName": "",
  "pageUrl": "",
  "pageCategory": "",
};